// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_GetByIdResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/menu_itens/getByID/{id}
 *
 * Returns a single menu item record (Menu_itens_model::get()->to_object()).
 * Field set mirrors the Menu_itens_record metadata.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MenuItens_GetByIdResponseDados {
menu_item_id: number
menu_item_titulo: string
menu_item_tipo: string
menu_item_icone: string
menu_item_controller: string
menu_item_url: string
menu_item_pai_id: string
menu_item_status: number
menu_item_ordem: number
menu_item_permissoes: string
}

export type MenuItens_GetByIdResponse = ApiResponse<MenuItens_GetByIdResponseDados>;

registerResponseContract('MenuItens_GetByIdResponse', {
  menu_item_id:         { type: 'number',  required: true },
  menu_item_titulo:     { type: 'string',  required: true },
  menu_item_tipo:       { type: 'string',  required: true },
  menu_item_icone:      { type: 'string',  required: true },
  menu_item_controller: { type: 'string',  required: true },
  menu_item_url:        { type: 'string',  required: true },
  menu_item_pai_id:     { type: 'string',  required: true },
  menu_item_status:     { type: 'number',  required: true },
  menu_item_ordem:      { type: 'number',  required: true },
  menu_item_permissoes: { type: 'string',  required: true },
})
